var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5598 16.13C37.7298 16.66 38.2198 17 38.7498 17C38.8798 17 38.9998 16.98 39.1298 16.94C39.7798 16.73 40.1498 16.03 39.9398 15.37L39.939 15.3675C39.8501 15.0995 34.8408 0 19.9998 0C5.15894 0 0.149578 15.0995 0.0606641 15.3675L0.0598354 15.37C-0.150165 16.03 0.209835 16.73 0.869835 16.94C1.52984 17.15 2.22984 16.79 2.43984 16.13C2.61984 15.57 6.94984 2.5 19.9998 2.5C33.0498 2.5 37.3798 15.57 37.5598 16.13ZM20 26C24.9706 26 29 21.9706 29 17C29 12.0294 24.9706 8 20 8C15.0294 8 11 12.0294 11 17C11 21.9706 15.0294 26 20 26Z",
    fill: "#9BCAEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityRange);
export default __webpack_public_path__ + "static/media/visibility-range.2737e0d8b6a91b3ddaf12fa4b0b35955.svg";
export { ForwardRef as ReactComponent };